export default {choose_newsletter:'Choose newsletters in the list.',email_please:'Your e-mail?'};